(function() {
    'use strict';
    angular.module('emarket.main.profile')
    .controller('ProfileEditionDialogController', ['$log', '$mdToast', '$document', '$timeout', '$mdDialog', '$q', 'Auth', 'File', 'Profile', 'Category', 'user', 'provinces', function($log, $mdToast, $document, $timeout, $mdDialog, $q, Auth, File, Profile, Category, user, provinces) {
        var vm = this;
        vm.saving = false;
        vm.provinces = provinces;
        if (!user.phones || (user.phones && user.phones.length === 0)) {
            user.phones = [ {
                number: null,
                type: null
            } ];
        }
        vm.user = user;

        vm.addEmptyEmail = function() {
            vm.user.emails.push({});
        };
        vm.addEmptyPhone = function() {
            vm.user.phones.push({});
        };
        vm.cancel = function() {
            $mdDialog.cancel();
        };

        vm.hide = function() {
            $mdDialog.hide();
        };

        vm.removeEmail = function(index) {
            vm.user.emails.splice(index, 1);
        };
        vm.removePhones = function(index) {
            vm.user.phones.splice(index, 1);
        };
        vm.categories = Category.$search({
            parentId: 0
        });
    // vm.validateEmail = function(email){
    //   //TODO: send validation
    // };
        vm.save = function(keepDialog) {
            vm.saving = true;
            var promise = $q.when();
            if (vm.file) {
                promise = File.create(vm.file);
            }

            return promise.then(function(file) {
                if (file) {
                    vm.user.picture = file;
                }
                return Profile.$find(vm.user._id).$asPromise();
            }).then(function(user) {
                var properties = [ 'displayName', 'address', 'picture', 'emails', 'phones', 'store' ];
                properties.forEach(function(key) {
                    if (vm.user[key]) {
                        user[key] = vm.user[key];
                    }
                });
                return user.$save(properties).$asPromise();
            }).then(function(response) {
                vm.saving = false;
                $log.info(response);
                if (!keepDialog) {
                    vm.hide(response);
                }
                Auth.setUser(response);
            }).catch(function(err) {
                vm.saving = false;
                $log.error(err);
            });
        };
        var uploadStoreCoverPicture = function(file) {
            var success = function(response) {
                $log.debug('Upload complete', response);
                vm.user.store.cover.image = response;
            };
            var progress = function (event) {
                var progressPercentage = parseInt(100 * event.loaded / event.total);
                $log.debug('progressPercentage %s', progressPercentage);
            };
            var error = function(err) {
                $log.error(err);
            };
            File.create(file).then(success, error, progress);
        };

        vm.uploadStoreCoverPicture = uploadStoreCoverPicture;


        vm.validate = function(phone) {
            vm.save(true).then(function() {
                Profile.showPhoneValidationDialog(phone).then(function() {
                    var element = $document[0].querySelector('md-dialog.edit-profile-dialog');
                    vm.user.phones.forEach(function(p) {
                        if(p.number === phone.number) {
                            p.status = 'validated';
                        }
                    });

                    $mdToast.show({
                        template: '<md-toast>Número '+ phone.number + ' validado</md-toast>',
                        position: 'bottom left',
                        parent: angular.element(element)
                    });
                });
            });
        };
    }]);
}());
